module.exports = __webpack_public_path__ + "static/media/Maf_SanRoman.48375994.jpg";